export default __webpack_public_path__ + "static/media/heart.ff07a788.mp3";